import { useEffect } from 'react';

export default function usePdfInitialPageNavigation({
  autoScrollRequestedRef,
  currentPage,
  containerRef,
  initialPage,
  setCurrentPage,
}) {
  useEffect(() => {
    if (!autoScrollRequestedRef.current) return;
    if (currentPage && containerRef.current) {
      const scrollToPage = () => {
        const pageElement = document.querySelector(`[data-page-number="${currentPage}"]`);
        if (pageElement && containerRef.current) {
          pageElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };

      scrollToPage();
      setTimeout(scrollToPage, 300);
      setTimeout(scrollToPage, 600);
      autoScrollRequestedRef.current = false;
    }
  }, [autoScrollRequestedRef, containerRef, currentPage]);

  useEffect(() => {
    const pageNum = typeof initialPage === 'string' ? parseInt(initialPage, 10) : initialPage;
    if (pageNum && Number.isFinite(pageNum)) {
      autoScrollRequestedRef.current = true;
      setCurrentPage(Math.max(1, pageNum));
    }
  }, [autoScrollRequestedRef, initialPage, setCurrentPage]);
}
